import { render, staticRenderFns } from "./PreferenceFeature.vue?vue&type=template&id=09edc1f7&"
import script from "./PreferenceFeature.vue?vue&type=script&lang=ts&"
export * from "./PreferenceFeature.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09edc1f7')) {
      api.createRecord('09edc1f7', component.options)
    } else {
      api.reload('09edc1f7', component.options)
    }
    module.hot.accept("./PreferenceFeature.vue?vue&type=template&id=09edc1f7&", function () {
      api.rerender('09edc1f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Preference/PreferenceFeature.vue"
export default component.exports